import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e844057"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calculator-additional" }

import { KEYS_FUNCTIONS, KEYS_ABC, KEYS_LESS } from '../type/constants';
import { inputLatex } from '../utils';
import KeyboardItem from './KeyboardItem.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Additional',
  props: {
  id: {
    type: Number,
    default: 1,
  },
  mathField: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;

const listItem: Record<string, any[]> = {
  1: [],
  2: KEYS_FUNCTIONS,
  3: [],
  4: KEYS_ABC,
  5: KEYS_LESS,
};
const handleClick = (key: string) => {
  inputLatex(props.mathField, key);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItem[props.id], (item) => {
      return (_openBlock(), _createBlock(KeyboardItem, {
        key: item.key,
        keyboard: item,
        onPressKey: handleClick
      }, null, 8, ["keyboard"]))
    }), 128))
  ]))
}
}

})